import type { IconData } from '@stacksjs/iconify-core'

export const basicUiFilter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 8.418A8 8 0 0 1 0 1V0h16v1a8 8 0 0 1-5 7.418V10a6 6 0 0 1-6 6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiFilter
